var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoxysmall = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95782 9.39418C9.95782 9.39418 6.185 12.517 7.54275 17.116C8.89762 21.7122 14.3806 24.6588 20.7447 22.7753L14.4384 14.8194C14.4384 14.8194 18.9768 13.817 18.9768 7.33444C18.9768 0.851886 11.4918 0.0863442 9.90005 0.0256786C8.3083 -0.0320982 0 0.0256786 0 0.0256786V21.8306L5.95389 17.8816C5.95389 17.8816 2.71262 12.283 7.72186 6.68445L6.19078 4.6796H13.3233L11.3791 10.9859L9.9636 9.39418H9.95782Z",
    fill: "#F40000"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoxysmall);
export default ForwardRef;